// import Message from 'components/molecules/alerts/Message';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import WatchClass from 'components/organisms/containers/WatchClass';
import WatchHeader from 'components/organisms/headers/WatchHeader';
import Meta from 'components/templates/Seo/Meta';
import useFeedback from 'hooks/useFeedback';
import useQueryParam from 'hooks/useQueryParam';
import useSnackbar from 'hooks/useSnackbar';

import { CircularProgress } from '@mui/material';

import SectionTitle from '@/components/atoms/fonts/SectionTitle';
import ButtonBack from '@/components/BI/buttonBack';
import useCourseService from '@services/course';

import { Header } from './styles';
// import { getCourseById, likeCourse } from 'services/courses';
// import { answerQuiz, finishClass } from 'services/courses/watch';

const Watch = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [course, setCourse] = useState();
    const [isliked, setIsLiked] = useState(false);
    const [likes, setLikes] = useState(0);
    const [favorited, setFavorited] = useState(null);
    const [progress, setProgress] = useState(0);
    const [activeClass, setActiveClass] = useState({});
    const [maxClass, setMaxClass] = useState(0);
    const [lastLesson, setLastLesson] = useState(false);
    const [allClassesCompleted, setAllClassesCompleted] = useState(false);
    const [finished, setFinished] = useState(false);
    const [quizAnswers, setQuizAnswers] = useState([]);

    const dispatch = useDispatch();
    const location = useLocation();
    const query = useQueryParam();
    const snackbar = useSnackbar();
    const feedback = useFeedback();
    const { getCoursePerId, completedClass, likeCourse } = useCourseService();

    const handleFavorite = async () => {
        favoriteList.openListModal(favorited, setFavorited, id, 'course');
    };

    const handleLike = (id) => {
        const previousLiked = isliked;
        const previousLikes = likes;

        setIsLiked(!previousLiked);
        setLikes(previousLiked ? previousLikes - 1 : previousLikes + 1);

        likeCourse(id).catch((err) => {
            setIsLiked(previousLiked);
            setLikes(previousLikes);
            snackbar(err.error || 'Erro ao curtir o curso.', 'error');
        });
    };

    const changeClass = async (value) => {
        const selectedClass = !isNaN(value) ? course.classes.find((classItem) => classItem.number === value) : course.test[0];
        setActiveClass(selectedClass);
    };

    // const answerQuizCall = async (questionId, answerId, index) => {
    //     await answerQuiz(questionId, answerId)
    //         .then(() => {
    //             const newAnswers = quizAnswers;
    //             newAnswers[activeClass.id][index] = answerId;
    //             setQuizAnswers(newAnswers);
    //         })
    //         .catch((error) => {
    //             snackbar(error.message, 'error');
    //         });
    // };

    // const getCourseData = useCallback(async () => {
    //     await getCourseById(id)
    //         .then((response) => {
    //             if (!response.data.registered) {
    //                 snackbar('Você não está inscrito no curso.', 'error');
    //                 navigate(`/aluno/cursos/curso/${id}`);
    //                 return;
    //             }
    //             setCourse(response.data);
    //         })
    //         .catch((error) => {
    //             setError(error.data.error);

    //             console.error(error);
    //             snackbar('Não foi possível carregar os cursos.', 'error');
    //         });
    // }, []);

    const fillQuizAnswers = () => {
        let quizAnswers = {};

        course.classes.map((cls) => {
            quizAnswers[cls.id] = cls?.quiz.flatMap((quiz) => {
                return quiz?.question
                    ? quiz?.question.map((question) => {
                          return question?.answerStudent ? question?.answerStudent.id_answer : null;
                      })
                    : [];
            });
        });

        return quizAnswers;
    };

    const fillData = () => {
        const getActualClassData = () => {
            if (course.classes?.length === 0) {
                snackbar('Não existem aulas para este curso.', 'error');
                return;
            }

            if (activeClass?.number === undefined) {
                return activeClass?.asking !== undefined ? course.classes[course.classes.length - 1] : course.classes[0];
            }

            const currentClass = course.classes.find((classData) => classData.number === Number(activeClass.number));

            if (!currentClass) {
                return course.classes[0];
            }

            return currentClass;
        };

        if (!course?.id) {
            return;
        }

        const actualClass = getActualClassData();
        // const quizAnswers = fillQuizAnswers();
        // setQuizAnswers(quizAnswers);
        // setIsLiked(1);
        // setLikes(12);
        setActiveClass(actualClass);
        // setMaxClass(course.completeMyStudent === 100 ? course.classes.length : Number(actualClass?.number) || 0);
        // setProgress(course.progress || 56);
        setLoading(false);
    };

    const nextClass = () => {
        const nextNumbered = course.classes.find(
            (classData) => classData.number !== undefined && classData.number === Number(activeClass.number) + 1
        );

        if (nextNumbered) {
            if (Number(activeClass.number) + 1 > maxClass) {
                setMaxClass(Number(activeClass.number) + 1);
            }

            window.scrollTo(0, 0);
            setActiveClass(nextNumbered);
            updateFinishClass(activeClass.id);
            return;
        }

        const quizItem = course.classes[course.classes.length - 1];

        window.scrollTo(0, 0);
        setActiveClass(quizItem);
        updateFinishClass(activeClass.id);
    };

    const lastClass = () => {
        if (activeClass?.asking !== undefined) {
            return setActiveClass(course.classes[course.classes.length - 2]);
        }

        const nextClass = course.classes.find((classData) => classData.number === Number(activeClass.number) - 1);

        if (Number(activeClass.number) - 1 > maxClass) {
            setMaxClass(Number(activeClass.number) - 1);
        }

        window.scrollTo(0, 0);
        setActiveClass(nextClass);
    };

    const calculateProgress = () => {
        if (!course?.classes) {
            return;
        }

        const lessonItems = course.classes.filter((classItem) => classItem?.asking === undefined && classItem?.number !== undefined);
        const totalClasses = lessonItems.length;

        const completedClasses = lessonItems.filter(
            (classItem) => classItem?.class_user?.is_completed === 1 || classItem?.myStudentComplete === true
        ).length;

        if (totalClasses === 0) {
            setProgress(0);
            setAllClassesCompleted(false);
            return;
        }

        const progress = Math.round((completedClasses / totalClasses) * 100);
        setProgress(progress);
        setAllClassesCompleted(completedClasses === totalClasses);
    };

    // const showMessage = (finishedClassIndex) => {
    //     if (finishedClassIndex + 1 === course.classes.length) {
    //         const courseWeight = course?.classes?.reduce((acc, curr) => acc + curr.peso, 0);
    //         feedback.finishCourse(courseWeight);
    //         return;
    //     }

    //     snackbar('Aula concluída com sucesso', 'success');
    // };

    // const handleFinish = (goToNextClass = false) => {
    //     setFinished(true);

    //     if (!activeClass.myStudentComplete) {
    //         finishClass(activeClass.id, auth?.user?.studentId)
    //             .then(() => {
    //                 const finishedClassIndex = course.classes.findIndex((classData) => classData.id === activeClass.id);
    //                 const finishedClass = course.classes[finishedClassIndex];

    //                 if (!finishedClass.myStudentComplete) {
    //                     showMessage(finishedClassIndex);
    //                 }

    //                 setFinished(true);
    //                 setCourse((prevCourse) => ({
    //                     ...prevCourse,
    //                     classes: prevCourse.classes.map((classData, index) => {
    //                         if (index === finishedClassIndex) {
    //                             return {
    //                                 ...classData,
    //                                 myStudentComplete: true
    //                             };
    //                         }

    //                         return classData;
    //                     })
    //                 }));
    //             })
    //             .then(() => {
    //                 if (goToNextClass) {
    //                     nextClass();
    //                 }
    //             })
    //             .catch((err) => console.error(err));
    //     } else {
    //         if (goToNextClass) {
    //             nextClass();
    //         }
    //     }
    // };

    const updateFinishClass = (id) => {
        completedClass(id);

        setCourse((prev) => {
            if (!prev?.classes) return prev;
            return {
                ...prev,
                classes: prev.classes.map((classItem) =>
                    classItem.asking === undefined && classItem.id === id
                        ? { ...classItem, class_user: { ...(classItem.class_user || {}), is_completed: 1 } }
                        : classItem
                )
            };
        });
    };

    const setSubNavbar = () => {
        dispatch({
            type: 'SET_RETURN',
            payload: {
                returnUrl: getReturnUrl(),
                returnText: 'Cursos',
                returnPath: location.pathname
            }
        });
    };

    const getReturnUrl = () => {
        const returnUrl = query.get('returnUrl');

        if (returnUrl) {
            return returnUrl;
        }

        return '/aluno/cursos';
    };

    useEffect(() => {
        if (course) {
            fillData();
        }
        calculateProgress();
    }, [course]);

    useEffect(() => {
        setSubNavbar();
        getCoursePerId(id)
            .then((resp) => {
                if (resp.data.test && resp.data.test.length > 0) {
                    resp.data.classes.push(resp.data.test[0]);
                }
                setCourse(resp.data);
                setIsLiked(resp.data.course_user.like === 0 ? false : true);
                setLikes(resp.data.likes);
                fillData();
            })
            .catch(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (course?.classes?.length === 0 || !activeClass?.id) {
            return;
        }

        setFinished(activeClass.myStudentComplete);
        setLastLesson(course?.classes && Number(activeClass.number) === course?.classes?.length);
        window.scrollTo(0, 0);
    }, [activeClass]);

    if (loading) {
        return <CircularProgress />;
    }

    if (course.classes.length === 0) {
        return <ButtonBack />;
    }

    // if (error || !course?.id || !course.classes) {
    //     return <Message text={error || ' Não foi possível carregar os dados do curso.'} />;
    // }

    return (
        <>
            <Meta title={`Assistir ${course?.title}`} />
            <ButtonBack />
            {/* <Header>
                <SectionTitle tituloString={course?.title} />
            </Header> */}
            <WatchHeader
                title={course?.title}
                classes={course?.classes}
                favorite={favorited}
                handleFavorite={handleFavorite}
                progress={progress}
                id={course.id}
                activeClassNumber={activeClass?.number}
                maxClassNumber={maxClass}
                changeClass={changeClass}
                finished={false}
                competences={course.competences}
                courseUser={course.course_user || null}
            />
            <WatchClass
                course_title={course?.title}
                watchClass={activeClass}
                liked={isliked}
                setLiked={() => handleLike(course.id)}
                likes={likes}
                nextClass={nextClass}
                lastClass={lastClass}
                // handleFinish={handleFinish}
                lastLesson={lastLesson}
                setFinished={setFinished}
                finishedCourse={course?.completeMyStudent === 100}
                // quizAnswers={quizAnswers[activeClass.id]}
                // answerQuiz={answerQuizCall}
                classes={course?.classes}
                activeClassNumber={activeClass?.number}
                courseUser={course.course_user || null}
                courseTitle={course.title}
                maxClassNumber={maxClass}
                changeClass={changeClass}
                progress={progress}
                finished={false}
                markClassCompleted={updateFinishClass}
            />
        </>
    );
};

export default Watch;
